import { ValidationObserver, ValidationProvider, extend, localize } from 'vee-validate'
import * as rules from 'vee-validate/dist/rules'
import es from 'vee-validate/dist/locale/es.json'

export default {
  install (Vue) {
    Vue.component('ValidationProvider', ValidationProvider)
    Vue.component('ValidationObserver', ValidationObserver)

    Object.keys(rules).forEach(rule => {
      extend(rule, rules[rule])
    })

    extend('greaterThanZero', {
      validate (value) {
        return Number(value) > 0
      },
      message: () => {
        return 'El Valor  debe ser mayor a cero'
      }
    })

    extend('notZero', {
      validate (value) {
        return Number(value) !== 0
      },
      message: () => {
        return 'El Valor no debe ser cero'
      }
    })

    localize('es', es)
  }
}
